import {
  Box,
  Button,
  ButtonColorVariant,
  ButtonVariant,
  Display,
  Icon,
  IconVariant,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import React from 'react'

type ExpandToggleProps = {
  isExpanded: boolean
  onToggle: () => void
}

const ChevronButton = withCitrusTheme(Button, () => ({
  padding: 0,
  minWidth: 0,
  minHeight: 0,
  height: 'auto',
  width: 'auto',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const ExpandToggle = ({ isExpanded, onToggle }: ExpandToggleProps) => {
  const ariaLabel = isExpanded ? 'Collapse delivery details' : 'Expand delivery details'
  const iconName = isExpanded ? 'chevron_up' : 'chevron_down'

  return (
    <>
      {/* Mobile / tablet */}
      <Box display={[Display.Flex, Display.Flex, Display.None]}>
        <ChevronButton
          variant={ButtonVariant.None}
          colorVariant={ButtonColorVariant.Tertiary}
          type="button"
          aria-label={ariaLabel}
          aria-expanded={isExpanded}
          onClick={onToggle}
          data-testid="order-card-expand-toggle-mobile"
        >
          <Icon name={iconName} variant={IconVariant.Actionable} size={6} />
        </ChevronButton>
      </Box>
      {/* Desktop */}
      <Box display={[Display.None, Display.None, Display.Flex]}>
        <ChevronButton
          variant={ButtonVariant.None}
          colorVariant={ButtonColorVariant.Tertiary}
          type="button"
          aria-label={ariaLabel}
          aria-expanded={isExpanded}
          onClick={onToggle}
          data-testid="order-card-expand-toggle-desktop"
        >
          <Icon name={iconName} variant={IconVariant.Actionable} size={10} />
        </ChevronButton>
      </Box>
    </>
  )
}
